import { Group, GroupDetail } from '@/entities/group';

export function intoEditable(data: GroupDetail): Group {
  return {
    ...data.data,
    title: data.data.title || '',
    users: data.data.users.map(user => user.id),
  };
}
